export default __webpack_public_path__ + "static/img1PR-780cf266977752f04476f8055b8956c1.png";